import { RootState } from '../store'
export const selectSecurityCheck = (state: RootState) =>
  state.securitycheckFamily.securityCheckFamilys
export const selectLoading = (state: RootState) =>
  state.securitycheckFamily.loading
export const selectError = (state: RootState) => state.securitycheckFamily.error

export const selectSecurityCheckData = (state: RootState) =>
  state.securitycheckFamily.data
export const subdomains = (state: RootState) =>
  state.securitycheckFamily.subDomainsByActionId
export const selectGlobalMaturityRateNIST = (state: RootState) =>
  state.securitycheckFamily.GlobalMaturityRateNIST

export const selectGlobalMaturityRate = (state: RootState) =>
  state.securitycheckFamily.GlobalMaturityRate

export const selectGlobalMaturityRateISO = (state: RootState) =>
  state.securitycheckFamily.GlobalMaturityRateISO
export const selectSecurityCheckFamiliesSwift = (state: RootState) =>
  state.securitycheckFamily.dataSwift
export const selectSecurityCheckFamiliesBySource = (state: RootState) =>
  state.securitycheckFamily.dataSource
